import { isMinor } from './format';

/**
 * Generate a vCard 3.0 string from a member object.
 */
export function generateVCard(member) {
    const minor = member.is_minor || isMinor(member.birthdate);
    const lastName = member.last_name || '';
    const firstName = member.first_name || '';
    const fullName = member.name || `${firstName} ${lastName}`.trim();
    const lines = [
        'BEGIN:VCARD',
        'VERSION:3.0',
        `N:${lastName};${firstName};;;`,
        `FN:${fullName}`,
    ];

    if (!minor && member.phone) {
        lines.push(`TEL;TYPE=CELL:${member.phone}`);
    }
    if (!minor && member.email) {
        lines.push(`EMAIL:${member.email}`);
    }
    if (!minor && member.address) {
        // ADR fields: PO Box;Extended;Street;City;State;Zip;Country
        // Put full address in the street field
        lines.push(`ADR;TYPE=HOME:;;${member.address};;;;`);
    }
    if (member.birthdate) {
        const d = member.birthdate.replace(/-/g, '').slice(0, 8);
        if (/^\d{8}$/.test(d)) {
            lines.push(`BDAY:${d}`);
        }
    }

    lines.push('END:VCARD');
    return lines.join('\r\n');
}

/**
 * Trigger a browser download of a .vcf file for the given member.
 */
export function downloadVCard(member) {
    const vcf = generateVCard(member);
    const blob = new Blob([vcf], { type: 'text/vcard;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const dlName = member.name || `${member.first_name || ''} ${member.last_name || ''}`.trim() || 'contact';
    a.download = `${dlName.replace(/[/\\?%*:|"<>]/g, '_')}.vcf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
